import { render, staticRenderFns } from "./TestimonialBlock.vue?vue&type=template&id=6d30e278&"
import script from "./TestimonialBlock.vue?vue&type=script&lang=js&"
export * from "./TestimonialBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports